import { SupportedSplTokens, CheckoutItem } from "../types";

/**
 * Options for creating a session
 */
export interface CreateSessionOptions {
  /**
   * Array of items which are going to be displayed on the checkout page
   */
  items: CheckoutItem[];
  /**
   * Array of SPL tokens in which the merchant accepts the payment in
   *
   * Currently supported SPL tokens are:
   * - `dust` -- https://explorer.solana.com/address/DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ
   * - `str` -- https://explorer.solana.com/address/5P3giWpPBrVKL8QP8roKM7NsLdi3ie1Nc2b5r9mGtvwb
  * - `samo` -- https://explorer.solana.com/address/7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU
   */
  tokens?: SupportedSplTokens[];
  /**
   * The URL to which the end-user is going to be redirected after the transaction is successful
   */
  success_url: string;
  /**
   * The URL to which the end-user is going to be redirected if the transaction is cancelled in between
   */
  cancel_url: string;
  shipping_fees?: number;
}

/**
 * Response of create session API request
 */
export interface CreateSessionResponse {
  message: string;
  /**
   * ID of the session
   */
  session_id: string;
  /**
   * Order ID which can be used for IRL shipments
   */
  order_id: string;
}
